import { createRouter, createWebHistory } from 'vue-router';

import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';

//#region modules
import TheOne from "@/module/TheOne/page/TheOne.vue"
import TheOneCallback from "@/module/TheOne/page/TheOneCallback.vue"

import Bitkub from "@/module/Bitkub/page/Bitkub.vue"
import BitkubCallback from "@/module/Bitkub/page/BitkubCallback.vue"
import BitkubError from "@/module/Bitkub/page/BitkubError.vue"

import PayWithPoint from "@/module/PayWithPoint/page/PayWithPoint.vue"
import ScanQr from "@/module/PayWithPoint/page/ScanQr.vue"
import LineLogin from "@/module/LineLogin/page/LineLogin.vue"

import YesCoin from "@/module/YesCoin/page/YesCoin.vue"

import MePoint from "@/module/MePoint/page/MePoint.vue"

import Layout from '@/module/Topup2C2p/component/Layout/Layout.vue'
import Auth from '@/module/Topup2C2p/page/Auth.vue'
import Topup2c2p from '@/module/Topup2C2p/page/Topup2c2p.vue'
import Topup2c2pList from '@/module/Topup2C2p/page/Topup2c2pList.vue'
import Topup2c2pDetail from '@/module/Topup2C2p/page/Topup2c2pDetail.vue'

import Announcement from '@/module/Announcement/page/Announcement.vue'

import Error from "@/module/Error/page/Error.vue"
import QrPayment from "@/module/QrPayment/page/QrPayment.vue"


//#endregion

const routes = [
    {
        path: '/',
        name: 'default',
        component: Default
    },

    //#region the one
    {
        path: '/theone',
        name: 'theone_landing',
        component: TheOne,
    },
    {
        path: '/theone/callback',
        name: 'theone_callback',
        component: TheOneCallback
    },
    {
        path: '/paywithpoint',
        name: 'paywithpoint_landing',
        component: PayWithPoint,
    },
    {
        path: '/linelogin',
        name: 'linelogin',
        component: LineLogin,
    },
    {
        path: '/linelogin/:routepath',
        name: 'linelogin_path',
        component: LineLogin,
    },
    {
        path: '/scanpaywithpoint',
        name: 'scanpaywithpoint',
        component: ScanQr,
    },
    {
        path: '/qrpayment',
        name: 'qrpayment',
        component: QrPayment,
    },
    //#endregion the one

    //#region bitkub
    {
        path: '/bitkub',
        name: 'bitkub_landing',
        component: Bitkub,
    },
    {
        path: '/bitkub/callback',
        name: 'bitkub_callback',
        component: BitkubCallback
    },
    {
        path: '/bitkub/error',
        name: 'bitkub_error',
        component: BitkubError
    },
    //#endregion

    //#region yes coin
    {
        path: '/yescoin',
        name: 'yescoin_landing',
        component: YesCoin,
    },
    //#endregion

    {
        path: '/mepoint',
        name: 'mepoint',
        component: MePoint,
    },
    {
        path: '/topup2c2p',
        name: 'topup2c2p_landing',
        component: Layout,
        children: [
            {
                path: '',
                name: 'topup2c2p_auth',
                component: Auth,
            },
            {
                path: 'home',
                name: 'topup2c2p_home',
                component: Topup2c2p,
            },
            {
                path: 'list/:categoryId',
                name: 'topup2c2p_list',
                component: Topup2c2pList,
            },
            {
                path: 'detail/:categoryId/:campaignId',
                name: 'topup2c2p_detail',
                component: Topup2c2pDetail,
            }
        ]
    },
    {
        path: '/announcement',
        name: 'announcement',
        component: Announcement,
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
    // Error
    {
        path: '/error/:error_code',
        name: 'error',
        component: Error,
    }, 
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
